import React, { useEffect, useState } from "react";
import { Table } from 'reactstrap';
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";
import { useTopTen } from "./hooks/useTopTen";
import DotsSpinner from "../Loader/DotsSpinner/DotsSpinner";
import { ITopTenTeacher, ITypeForTopTen } from "../../types";
type IData = {
  employId: string;
  name: string;
  schoolName: string;
  schoolCode: string;
  district: string;
};

type IProp = {
  type: ITypeForTopTen;
  district: string;
  block: string;
  week_no: number;
}
export default function TopTen({ type, district, block, week_no }: IProp) {
  const {
    isLoading,
    isFirst,
    setIsFirst,
    setParamsValue,
    getTopTenData,
    data,
    teacherData
  } = useTopTen()

  useEffect(() => {
    if (isFirst) {
      //   setParamsValue(param)
      setIsFirst(false);
    } else {
      getTopTenData(district, block, type, week_no);
    }
  }, [isFirst]);


  return (
        <>
          {isLoading ? (
            <div style={{ height: "60vh" }}>
              <DotsSpinner />
            </div>
          ) :
            (
              <>
                { type?.for=="student" ?
                  data?.length ? (
                  <div className="d-flex flex-wrap">
                    {/* <h3>Top 10 {type?.type}</h3> */}
                    <Table hover striped>
                      <tr>
                        <th className="px-2 text-sm">Srn No.</th>
                        <th className="px-4 text-sm">Name</th>
                        <th className="px-3 text-sm">Grade</th>
                        <th className="px-4 text-sm"> School</th>
                        <th className="px-3 text-sm">Block</th>
                        <th className="px-3 text-sm">District</th>
                        <th className="px-2 text-sm">
                          {type?.type?.trim() == "Total_time_tests"
                            ? "Time in Tests"
                            : type?.type.trim() == "avgStudentUsage"
                              ? "Total Usage (in mins)"
                              : type?.type.trim() == "Total_time_videos"
                                ? "Total Usage (in mins)"
                                : type?.type.trim() == "Total_Assignments"
                                  ? "Total Assignments"
                                  : type?.type.trim() == "Avg_Remedial"
                                    ? "Avg_Remedial"
                                    : type?.type.trim() == "Total_queries_raised"
                                      ? "Total queries raised"
                                      : type?.type.trim() == "Total_queries_solved"
                                        ? "Total queries solved"
                                        : ""}
                        </th>
                      </tr>
                      <tbody>
                      {data?.map((e) => (
                        <tr>
                          <td>{e?.student_srn ?? ""}</td>
                          <td>{e?.student_name ?? ""}</td>
                          <td>{e?.grade ?? ""}</td>
                          <td>{e?.school ?? ""}</td>
                          <td>{e?.block ?? ""}</td>
                          <td>{e?.district ?? ""}</td>
                          <td>
                            {type?.type.trim() == "Total_time_tests"
                              ? e?.Total_time_tests
                              : type?.type.trim() == "avgStudentUsage"
                                ? e?.total_usage
                                : type?.type.trim() == "Total_time_videos"
                                  ? e?.Total_time_videos
                                  : type?.type.trim() == "Total_Assignments"
                                    ? e?.Total_Assignments
                                    : type?.type.trim() == "Avg_Remedial"
                                      ? e?.remedial
                                      : type?.type.trim() == "Total_queries_raised"
                                        ? e?.Total_queries_raised
                                        : type?.type.trim() == "Total_queries_solved"
                                          ? e?.Total_queries_solved
                                          : ""}
                          </td>
                        </tr>
                      ))}
                      </tbody>
                    </Table>
                  </div>
                )
                  : (
                    <div className="d-flex justify-content-center">
                    <h1> No Data Found</h1>
                    </div>
                  )
                  : 
                  type?.for =="teacher" ?
                   <Table striped hover >
                    <tr>
                      <th className="px-2 text-sm">Emp. code</th>
                      <th className="px-2 text-sm">Teacher Name</th>
                      <th className="px-2 text-sm">School</th>
                      <th className="px-2 text-sm">Block</th>
                      <th className="px-2 text-sm">District</th>
                      {type?.type=="total_pall_usage_in_min_teacher" ?<th className="px-2 text-sm">Total usage (in Min)</th> : type?.type =="timeSpentOnStudentMonitoring" ? <th className="px-2 text-sm">Time on Student Monitoring (in mins)</th> : <th className="px-2 text-sm">Homework /Assignments</th> }
                    </tr>
                    <tbody>
                    {teacherData ? teacherData?.map((e:ITopTenTeacher)=>(
                       <tr>
                         <td>{e?.emp_code}</td>
                         <td>{e?.name}</td>
                         <td>{e?.school}</td>
                         <td>{e?.block}</td>
                         <td>{e?.district}</td>
                         {type?.type=="total_pall_usage_in_min_teacher" ?<td>{e?.Total_usage_in_min}</td> : type?.type =="timeSpentOnStudentMonitoring" ? <td>{e?.time_usage_in_min}</td> : <td>{e?.Total_assessments}</td>}
                       </tr>
                    )) :<tr ><td colSpan={6}><h1 className="text-center text-muted">No teacher present in top ten List</h1></td></tr>}
                    </tbody>
                   </Table>
                   :<div className="d-flex justify-content-center">
                   <h1> No Data Found</h1>
                   </div>
                  }
              </>
            )}
        </>
  );
}
